<template>
    <v-row v-if="order">
        <v-col cols="12" class="pb-0">
            <div class="pl-3">
                <span class="text-body-2">{{ sellerName }}</span>
                <v-row
                    v-if="products.length > 0"
                    v-for="product in products"
                    :key="product.id"
                    class="my-1 mx-1 text-body-1 font-weight-regular black--text"
                >
                    <v-col cols="4" class="text-truncate pa-0">
                        {{ product.name }}
                    </v-col>
                    <v-col cols="3" class="pa-0 text-center">
                        {{ product.quantity }}
                    </v-col>
                    <v-col cols="5" class="px-0 text-right pa-0">
                        <span>{{ product.formatPrice }}</span>
                        <span class="text-lowercase">{{currency.cyrName}}</span>
                    </v-col>
                </v-row>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import OrderDataProvider from "../../../../app-front/mixins/OrderDataProvider";
import numberFormat from "../../../../utils/numberFormat";

export default {
    name: "OrderAmountRow",
    mixins: [ OrderDataProvider ],
    props: [ 'order' ],
    computed: {
        currency() {
            return this.$store.getters.currencies.find(item => item.id === 1)
        },
        sellerName() {
            if(!this.order || !this.order.seller) return null;
            return this.order.seller.companyName || `${this.order.seller.firstName} ${this.order.seller.lastName}`;
        },
        products() {
            const inProcessOrder = this.inProcessProducts.find(item => item.sellerID === this.order.seller.id);
            if(!inProcessOrder.products) return []

            return inProcessOrder.products.map(item => {
                const orderProduct =  this.order.data.find(product => product.id === item.id);
                const price = item.calculatedPrice * (1 - inProcessOrder.totalDiscount / 100);
                const quantity = this.orderQuantityValue(item.quantity, orderProduct.pack);
                return {
                    name: orderProduct.productName,
                    quantity: `${quantity} ${orderProduct.pack.unitName}`,
                    formatPrice: numberFormat(price, 2, '.', ' ')
                }
            })
        },
    },
    methods: {
        orderQuantityValue(quantity, pack) {
            if (!quantity) return null;

            const minValue = pack.minValue;
            const value = pack.value;
            let quantityWeight = value * quantity;

            if (minValue > 0) {
                quantityWeight *= minValue;
            }

            return quantityWeight
        },
    }
}
</script>

<style scoped>

</style>
